<template>
  <vs-col vs-w="12" class="mt-2">
    <vs-row vs-w="12">
      <label for="" class="vs-input--label">{{ label }}</label>
    </vs-row>

    <vs-row vs-w="12" v-if="limit">
      <vs-col vs-lg="10" vs-sm="9" vs-xs="10">
        <vs-row vs-w="12" class="mt-3">
          <div vs-justify="flex-start">
            <vs-row vs-w="12">
              <label for="" class="vs-input--label">Allowed from</label>
            </vs-row>
            <vs-row vs-w="12" vs-justify="flex-start">
              <span class="mx-2 my-auto">Hours before</span>
              <vs-input
                type="number"
                :min="0"
                v-model="fromHours"
                class="booking-policy-limit-hours-input"
                :disabled="fromAlways"
              />
              <span class="mx-2 my-auto">:</span>
              <minutes-dropdown
                :from-minute="0"
                :to-minute="59"
                :minute-interval="15"
                v-model="fromMinutes"
                :disabled="fromAlways"
              />
              <span class="mx-2 my-auto">&nbsp;Or </span>
              <vs-checkbox v-model="fromAlways">Always</vs-checkbox>
            </vs-row>
          </div>
        </vs-row>

        <vs-row class="mt-3">
          <div>
            <vs-row vs-w="12">
              <label for="" class="vs-input--label">Allowed until</label>
            </vs-row>
            <vs-row vs-w="12" vs-justify="flex-start">
              <span class="mx-2 my-auto">Hours before</span>
              <vs-input
                type="number"
                :min="0"
                v-model="toHours"
                class="booking-policy-limit-hours-input"
              />
              <span class="mx-2 my-auto">:</span>
              <minutes-dropdown
                :from-minute="0"
                :to-minute="59"
                :minute-interval="15"
                v-model="toMinutes"
              />
            </vs-row>
          </div>
        </vs-row>

        <vs-row class="mt-3">
          <label for="" class="vs-input--label"
            >Relative to Opening Hours Policy</label
          >
        </vs-row>
        <vs-row class="mt-2">
          <vs-radio
            class="mr-2"
            v-model="relativeToValue"
            :vs-name="'booking-hours-policy-limit-' + limit.limitType"
            :vs-value="BOOKING_HOURS_RELATIVE_TARGET.OpeningTime"
            >From value</vs-radio
          >
          <vs-radio
            v-model="relativeToValue"
            :vs-name="'booking-hours-policy-limit-' + limit.limitType"
            :vs-value="BOOKING_HOURS_RELATIVE_TARGET.ClosingTime"
            >To value</vs-radio
          >
        </vs-row>
      </vs-col>

      <vs-col vs-lg="2" vs-sm="3" vs-xs="2">
        <vs-row class="h-full" vs-w="12" vs-align="flex-end">
          <vs-button
            @click="handleRemoveClick"
            type="filled"
            color="danger"
            icon="remove"
            class="my-auto"
          ></vs-button>
        </vs-row>
      </vs-col>
    </vs-row>

    <vs-row vs-w="12" v-if="!limit" vs-align="center">
      <vs-col vs-lg="10" vs-sm="9" vs-xs="10">
        <span class="ml-2 mr-4">No Limit</span>
      </vs-col>

      <vs-col vs-lg="2" vs-sm="3" vs-xs="2">
        <vs-button
          @click="handleAddClick"
          type="filled"
          color="success"
          icon="add"
        ></vs-button>
      </vs-col>
    </vs-row>
  </vs-col>
</template>

<script>
import * as _ from "lodash";
import moment from "moment";
import "moment-timezone";
import MinutesDropdown from "../MinutesDropdown.vue";
import { BOOKING_HOURS_RELATIVE_TARGET } from "@/store/modules/marcom/data-model/policy-configurations";

export default {
  props: {
    limit: {
      type: Object,
    },
    limitType: {
      type: Number,
    },
    label: {
      type: String,
    },
  },
  components: {
    MinutesDropdown,
  },
  data() {
    return {
      BOOKING_HOURS_RELATIVE_TARGET,
    };
  },
  computed: {
    relativeToValue: {
      get() {
        return this.limit.target;
      },
      set(value) {
        this.limit.target = value;
      },
    },
    fromAlways: {
      get() {
        return !this.limit.bookingAllowedFrom;
      },
      set(value) {
        if(value === true) {
          this.limit.bookingAllowedFrom = undefined;
        }
        else {
          this.limit.bookingAllowedFrom = "-02:00";
        }
      }
    },
    fromHours: {
      get() {
        if (!this.limit || !this.limit.bookingAllowedFrom) return undefined;
        let momentDuration = moment.duration(this.limit.bookingAllowedFrom);
        return Number.parseInt(Math.abs(momentDuration.hours()));
      },
      set(value) {
        let hours = value * -1;
        let momentDuration = moment.duration(this.limit.bookingAllowedFrom);
        let minutes = _.padStart(Math.abs(momentDuration.minutes()), 2, "0");
        this.limit.bookingAllowedFrom = `${hours}:${minutes}:00`;
      },
    },
    fromMinutes: {
      get() {
        if (!this.limit || !this.limit.bookingAllowedFrom) return undefined;
        let momentDuration = moment.duration(this.limit.bookingAllowedFrom);
        return Number.parseInt(Math.abs(momentDuration.minutes()));
      },
      set(value) {
        let minutes = _.padStart(value, 2, "0");
        let momentDuration = moment.duration(this.limit.bookingAllowedFrom);
        let hours = momentDuration.hours();
        this.limit.bookingAllowedFrom = `${hours}:${minutes}:00`;
      },
    },
    toHours: {
      get() {
        if (!this.limit || !this.limit.bookingAllowedUntil) return undefined;
        let momentDuration = moment.duration(this.limit.bookingAllowedUntil);
        return Number.parseInt(Math.abs(momentDuration.hours()));
      },
      set(value) {
        let hours = value * -1;
        let momentDuration = moment.duration(this.limit.bookingAllowedUntil);
        let minutes = _.padStart(Math.abs(momentDuration.minutes()), 2, "0");
        this.limit.bookingAllowedUntil = `${hours}:${minutes}:00`;
      },
    },
    toMinutes: {
      get() {
        if (!this.limit || !this.limit.bookingAllowedUntil) return undefined;
        let momentDuration = moment.duration(this.limit.bookingAllowedUntil);
        return Number.parseInt(Math.abs(momentDuration.minutes()));
      },
      set(value) {
        let minutes = _.padStart(value, 2, "0");
        let momentDuration = moment.duration(this.limit.bookingAllowedUntil);
        let hours = momentDuration.hours();
        this.limit.bookingAllowedUntil = `${hours}:${minutes}:00`;
      },
    },
  },
  methods: {
    handleRemoveClick() {
      setTimeout(() => {
        this.$emit("limit-removed", this.limitType);
      }, 10);
    },
    handleAddClick() {
      setTimeout(() => {
        this.$emit("limit-added", this.limitType);
      }, 10);
    },
  },
}
</script>

<style lang="scss" scoped>
.booking-policy-limit-hours-input {
  width: 55px;
}
</style>
